import * as React from 'react';
import Button from '@mui/material/Button';
import cn from 'classnames';

import { TurnButtonProps } from '../../types';

import { useTheme } from '../../../../theme';

import { ChevronLeft, Chevron, ArrowForward } from '../../../../Icons';

const TurnButton: React.FC<TurnButtonProps> = ({
	variant = 'goTo',
	classes,
	children,
	disabled,
	disableElevation = true,
	...restProps
}) => {
	const { TurnButton: theme } = useTheme('BaseComponents');

	const icon = variant === 'goTo' ? ArrowForward : variant === 'prev' ? ChevronLeft : Chevron;

	return (
		<Button
			variant="contained"
			classes={{
				...classes,
				root: cn(theme.root, theme[variant], classes?.root),
				disabled: cn(theme.disabled, classes?.disabled)
			}}
			disabled={disabled}
			disableElevation={disableElevation}
			{...restProps}
		>
			{icon}
		</Button>
	);
};

export default TurnButton;
